import Link from 'next/link';
import { FC } from 'react';

import {
  FacebookIcon,
  InstagramIcon,
  TelegramIcon
} from '@/components/ui/Icons/Icons';
import { CONFIG } from '@/config';

import * as S from './SocialLinks.styles';

interface SocialLinksProps {
  gap?: number;
}

const {
  contacts: { facebookLink, instagramLink, telegramLink }
} = CONFIG;

export const SocialLinks: FC<SocialLinksProps> = ({ gap = 20 }) => {
  return (
    <S.Wrapper $gap={gap}>
      <S.IconButton
        aria-label="Link to instagram"
        data-cy="social-link-instagram"
        as={Link}
        target="_blank"
        href={instagramLink}
      >
        <InstagramIcon />
      </S.IconButton>
      <S.IconButton
        aria-label="Link to facebook"
        data-cy="social-link-facebook"
        as={Link}
        target="_blank"
        href={facebookLink}
      >
        <FacebookIcon />
      </S.IconButton>
      <S.IconButton
        aria-label="Link to telegram"
        data-cy="social-link-telegram"
        as={Link}
        target="_blank"
        href={telegramLink}
      >
        <TelegramIcon />
      </S.IconButton>
    </S.Wrapper>
  );
};
